import React from "react";
import "./SettingsNewHistoryMainbox.css";

function HistoryMainbox() {
  return <div className="settingsnewhistorymainbox"></div>;
}

export default HistoryMainbox;
